import Vue from 'vue';
import Router from 'vue-router';
import Admissions from './views/Admissions.vue';

Vue.use(Router);

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'Admissions',
      component: Admissions
    },
    {
      path: '/notification-center',
      name: 'Centre de notifications',
      component: () => import('./views/NotificationCenter.vue')
    },
    {
      path: '/notification-center/email',
      name: 'Centre de notifications - Email',
      component: () => import('./views/NotificationCenterEmail.vue')
    },
    {
      path: '/notification-center/sms',
      name: 'Centre de notifications - SMS',
      component: () => import('./views/NotificationCenterSms.vue')
    },
    {
      path: '/liste-langues',
      name: 'Liste langue',
      component: () => import('./views/LangList.vue')
    },
    {
      path: '/niveau-langue',
      name: 'Niveau langue',
      component: () => import('./views/LangLevelList.vue')
    }
  ]
});
